<div id="adm1n-surveys-list" class="page-layout carded small-top left-sidebar inner-scroll">

  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center h-100-p">

    <!-- HEADER -->
    <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="['/']">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div fxLayout="column" fxLayoutAlign="start start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
          <div class="h2">Surveys</div>
          <div class="subtitle secondary-text">
            <span>All</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->
      <span fxFlex></span>

      <button class="button-menu-bar" mat-icon-button (click)="changeDisplay()">
        <mat-icon *ngIf="display==='list'">apps</mat-icon>
        <mat-icon *ngIf="display==='grid'">menu</mat-icon>
      </button>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <ng-container *ngIf="(surveysListService.store$ | async) as surveyList">
      <div class="content-card h-100-p w-100-p">
        <app-surveys-list [display]="display"></app-surveys-list>
      </div>
    </ng-container>

  </div>

</div>
